import React from 'react';
import { agent } from '../../data/content';
import { AgentPortrait } from '../ui/AgentPortrait';
import { CtaButton } from '../ui/CtaButton';
const credentials = [{
  label: 'Licencia de Agente',
  value: 'Agente FIFA'
}, {
  label: 'Licencia de Director Técnico',
  value: 'PRO ATFA-CONMEBOL'
}, {
  label: 'Área',
  value: 'Gestión y representación deportiva'
}];
export function About() {
  return <section aria-labelledby="sobre-title" className="w-full bg-ink-950" data-id="element-14" data-mp="az7jzd9t7u7t">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center md:py-24" data-id="element-15" data-mp="60mn9ntrnso4">
        <AgentPortrait size="lg" data-id="element-16" data-mp="js15hsfunpu4" />
        <p className="mt-8 text-sm font-semibold text-subtle" data-id="element-17" data-mp="jt2s8u68a0ro">Quién te asesora</p>
        <h2 id="sobre-title" className="mt-3 font-display text-4xl font-black leading-tight text-white md:text-5xl" data-id="element-18" data-mp="f0suiryvfweu">
          {agent.name}
        </h2>
        <p className="mt-3 text-base font-bold text-brand-gold md:text-lg" data-id="element-19" data-mp="3jfj08yq0i21j">{agent.credential}</p>
        <p className="mt-1 text-[15px] text-body" data-id="element-20" data-mp="3398dw202lozt">{agent.specialty}</p>

        <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-body" data-id="element-21" data-mp="3375qlpqay9ys">{agent.bio}</p>

        <div className="mt-10 w-full border-t border-ink-border pt-10" data-id="element-22" data-mp="386id29d9hf0u">
          <p className="font-display text-6xl font-black leading-none text-white" data-id="element-23" data-mp="3d0323bwvmynw">10</p>
          <p className="mt-2 text-[15px] text-body" data-id="element-24" data-mp="3hyed3pywrf7p">años de experiencia en el mundo del fútbol</p>
        </div>

        <dl className="mt-10 grid w-full gap-6 sm:grid-cols-3" data-id="element-25" data-mp="2kbfjxp7fcpek">
          {credentials.map(item => <div key={item.label} data-id="element-26" data-mp="2pa8rl1015m6t">
              <dt className="text-xs font-semibold text-subtle" data-id="element-27" data-mp="2pbad5zeo9r2s">{item.label}</dt>
              <dd className="mt-1 text-[15px] font-semibold text-white" data-id="element-28" data-mp="2u78xnbwvqoxx">{item.value}</dd>
            </div>)}
        </dl>

        <div className="mt-10" data-id="element-29" data-mp="9ibee9prx0vi">
          <CtaButton data-id="element-30" data-mp="9h9qv5rkmlww" />
        </div>
      </div>
    </section>;
}